export default __webpack_public_path__ + "static/ocean-d2334a22763ad7082774c009f238343e.mp4";